import {Component, Pipe, PipeTransform, Injectable} from '@angular/core';
import { Park } from '../../dataTypes/Park';

@Pipe({
  name: 'visibilityPermissionsTranslatePipe',
    pure: false
})
@Injectable()
export class visibilityPermissionsTranslatePipe implements PipeTransform {

  transform(filter: number): string {
       
  //1-Guests Only, 2-Monthly Parkers Only, 0-All
    if (filter === 1)
      return 'אורחים';
    if (filter === 2)
      return 'מנויים';
    if (filter === 0)
      return 'אורחים ומנויים';
    }
}
